export enum TrainingAnonymousStatusModel {
    Ok = 0,
    NotInFuture = 1,
    BookedUp = 2,
    Cancelled = 3
}